import {
  ClipboardPipeline,
  ClipboardInputTransformationEvent,
  Plugin,
  ViewDocumentFragment,
  ViewElement,
} from "ckeditor5";

export default class PasteFromMathType extends Plugin {
  init() {
    const clipboard = this.editor.plugins.get(ClipboardPipeline);

    clipboard.on<ClipboardInputTransformationEvent>(
      "inputTransformation",
      (_e, data) => {
        cleanupMathTypeWordTags(data.content);
      },
    );
  }
}

function cleanupMathTypeWordTags(
  container: ViewDocumentFragment | ViewElement,
) {
  let isMultilineStarted = false;

  for (const child of Array.from(container.getChildren())) {
    if (!child.is("view:element")) continue;
    if (child.index == null) continue;

    if (!Array.from(child.getClassNames()).includes("MTDisplayEquation")) {
      cleanupMathTypeWordTags(child);
      continue;
    }

    const foundDelimiter = checkForLatexMultilineDelimiters(child);
    if (foundDelimiter === 1) isMultilineStarted = true;

    if (isMultilineStarted) {
      const texts = Array.from(child.getChildren()).filter((c) =>
        c.is("$text"),
      );
      container._insertChild(child.index, texts);
      child._remove();
    }

    if (foundDelimiter === -1) isMultilineStarted = false;
  }
}

function checkForLatexMultilineDelimiters(element: ViewElement) {
  let delimiterCounter = 0;

  for (const child of element.getChildren()) {
    if (child.is("view:element")) {
      delimiterCounter += checkForLatexMultilineDelimiters(child);
    }
    if (child.is("view:$text")) {
      const matches = child.data.matchAll(/(\\\[)|(\\\])/g);
      for (const match of matches) {
        if (match[0] === "\\[") delimiterCounter++;
        if (match[0] === "\\]") delimiterCounter--;
      }
    }
  }

  return delimiterCounter;
}
